// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo_logo__1Ev9K","logoImage":"Logo_logoImage__DBCd5","logoText":"Logo_logoText__1zAVu","firstPart":"Logo_firstPart__2WY6D","secondPart":"Logo_secondPart__j62e4"};